import {IServicePerformanceState} from '../state'
import {
  IUpdateCombineTagsSuccessActionInt,
  IUpdateCompaniesFilterSuccessActionInt,
  IUpdateServicesFilterSuccessActionInt,
} from '../actions/load-services-int'
import {getfilteredData, getfilteredSites} from '../methods/load-filter-data-int'
import {IUpdateSitesCompaniesFilterSuccessActionInt} from '../actions/load-sites-map-data'
import {AsyncActionState} from '@telstra-connect/standard-actions/async-action'

export const updateServicesSuccessReducer = (
  state: IServicePerformanceState,
  action: IUpdateServicesFilterSuccessActionInt,
) => {
  const updatedServicesFilters = (action as IUpdateServicesFilterSuccessActionInt).data.services
    .searchString
  const updatedUserType = (action as IUpdateServicesFilterSuccessActionInt).data.services.userType
  state.servicesInt.data.filterInt.services.userType = updatedUserType
  const updateFilterString = state.servicesInt.data
  updateFilterString.filterInt.services.searchString = updatedServicesFilters
  updateFilterString.filterInt.services.userType = updatedUserType

  const companies =
    (action as IUpdateServicesFilterSuccessActionInt).data.companies &&
    (action as IUpdateServicesFilterSuccessActionInt).data.companies.length > 0
      ? (action as IUpdateServicesFilterSuccessActionInt).data.companies
      : state.servicesInt.data.filterInt.companies
  const locations =
    (action as IUpdateServicesFilterSuccessActionInt).data.locations &&
    (action as IUpdateServicesFilterSuccessActionInt).data.locations.length > 0
      ? (action as IUpdateServicesFilterSuccessActionInt).data.locations
      : state.servicesInt.data.filterInt.locations
  const serviceType =
    (action as IUpdateServicesFilterSuccessActionInt).data.serviceTypes &&
    (action as IUpdateServicesFilterSuccessActionInt).data.serviceTypes.length > 0
      ? (action as IUpdateServicesFilterSuccessActionInt).data.serviceTypes
      : state.servicesInt.data.filterInt.serviceTypes

  return {
    ...state,
    servicesInt: {
      ...state.servicesInt,
      status: AsyncActionState.Success,
      data: {
        ...state.servicesInt.data,
        filterInt: {
          ...state.servicesInt.data.filterInt,
          services: {
            ...state.servicesInt.data.filterInt.services,
            searchString:
              updatedServicesFilters !== undefined
                ? updatedServicesFilters
                : state.servicesInt.data.filterInt.services.searchString,
            userType:
              updatedUserType !== undefined
                ? updatedUserType
                : state.servicesInt.data.filterInt.services.userType,
          },
        },
        services: getfilteredData(updateFilterString, companies, {
          locations,
          serviceTypes: serviceType,
        }),
      },
    },
  }
}

export const updateCompaniesSuccessReducer = (
  state: IServicePerformanceState,
  action: IUpdateCompaniesFilterSuccessActionInt,
) => {
  const updatedCompanies = (action as IUpdateCompaniesFilterSuccessActionInt).data.companies
  return {
    ...state,
    servicesInt: {
      ...state.servicesInt,
      status: AsyncActionState.Success,
      data: {
        ...state.servicesInt.data,
        filterInt: {
          ...state.servicesInt.data.filterInt,
          companies: [...updatedCompanies],
        },
        services: getfilteredData(state.servicesInt.data, updatedCompanies, {
          locations: state.servicesInt.data.filterInt.locations,
          serviceTypes: state.servicesInt.data.filterInt.serviceTypes,
        }),
      },
    },
  }
}

export const updateSitesCompaniesSuccessReducer = (
  state: IServicePerformanceState,
  action: IUpdateSitesCompaniesFilterSuccessActionInt,
) => {
  const updatedCompanies = (action as IUpdateSitesCompaniesFilterSuccessActionInt).data.companies
  return {
    ...state,
    sitesMapData: {
      ...state.sitesMapData,
      data: {
        ...state.sitesMapData.data,
        sites: getfilteredSites(state.sitesMapData.data, updatedCompanies),
      },
    },
  }
}

export const updateCombineTagsSuccessReducer = (
  state: IServicePerformanceState,
  action: IUpdateCombineTagsSuccessActionInt,
) => {
  const updatedCombineTags = (action as IUpdateCombineTagsSuccessActionInt).data
  return {
    ...state,
    servicesInt: {
      ...state.servicesInt,
      data: {
        ...state.servicesInt.data,
        filterInt: {
          ...state.servicesInt.data.filterInt,
          locations: updatedCombineTags.locations,
          serviceTypes: updatedCombineTags.serviceTypes,
        },
        services: getfilteredData(
          state.servicesInt.data,
          state.servicesInt.data.filterInt.companies,
          updatedCombineTags,
        ),
      },
    },
  }
}
